import React, { useEffect } from "react";
import makeStyles from '@mui/styles/makeStyles';
import LottieFilePlayer from "components/LottieFilePlayer";

const useStyles = makeStyles((theme) => ({
  notFoundWrapper: {
    display: "flex",
    height: "100%",
    textAlign: 'center',
    justifyContent: "center",
    alignItems: "center"
  }
}));

export default function NotFound() {
  const classes = useStyles();
  const animationStyle = { height: "400px" };
  const [lottieFile, setLottieFile] = React.useState("");
  const lottieFileSrc = `${process.env.REACT_APP_CDN_LOTTIES_URL}404Error.json`;

  useEffect(() => {
    fetch(lottieFileSrc)
      .then(response => response.json())
      .then(data => {
        setLottieFile(data);
      });
  }, [lottieFileSrc]);

  return (
    <div className={classes.notFoundWrapper}>
      <LottieFilePlayer lottieFile={lottieFile} loop={true} style={animationStyle} />
    </div>
  );
}